import React from 'react';
import Header from './components/header/GlobalHeader';
import { render } from 'react-dom';
import './creatori.css';
import Fixed from './components/Fixed/Fixed';
import Collezione from './components/Collezione/Collezione'
import Atelier from './components/Atelier/Atelier';
import ComeNasce from './components/ComeNasce/ComeNasce';
import Contatti from './components/Contatti/Contatti';
import Home from './components/Home/Home';
window.onscroll = function() {myFunction()};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("myBar").style.width = scrolled + "%";
}

const headerElement = document.getElementById("header");
render(
  <React.StrictMode>
    <Header></Header>
  </React.StrictMode>,
  headerElement
);

const homeElement = document.getElementById("home");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <Home></Home>
    </Fixed>
  </React.StrictMode>,
  homeElement
);

const collezioneElement = document.getElementById("collezione");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <Collezione />
    </Fixed>
  </React.StrictMode>,
  collezioneElement
);

const atelierElement = document.getElementById("atelier");
render(
  <React.StrictMode>
    <Fixed >
      <Atelier></Atelier>
  </Fixed>
  </React.StrictMode>,
  atelierElement
);

const comeNasceElement = document.getElementById("comeNasce");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <ComeNasce></ComeNasce>
    </Fixed>
  </React.StrictMode>,
  comeNasceElement
);
const contattiElement = document.getElementById("contatti");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <Contatti></Contatti>
    </Fixed>
  </React.StrictMode>,
  contattiElement
);
